/* eslint-disable @typescript-eslint/no-explicit-any */
import { addTrace } from '@sparkai/monitoring'
import { useCallback, useState } from 'react'

export type ClickInfo = {
  mouseMoved: boolean
  hovered: boolean
  focused: boolean
}

export function useButtonClickVerification() {
  const [clickInfo, setClickInfo] = useState<ClickInfo>({
    mouseMoved: false,
    hovered: false,
    focused: false,
  })

  const handleMouseMove = useCallback(() => {
    setClickInfo((prev) => ({ ...prev, mouseMoved: true }))
  }, [])

  const handleMouseOver = useCallback(() => {
    setClickInfo((prev) => ({ ...prev, hovered: true }))
  }, [])

  const handleFocus = useCallback(() => {
    setClickInfo((prev) => ({ ...prev, focused: true }))
  }, [])

  const getIsHumanLikeClick = useCallback(() => {
    const status = (clickInfo.mouseMoved || clickInfo.focused) && (clickInfo.hovered || clickInfo.focused)

    const data = {
      ...clickInfo,
    }

    return {
      data,
      status,
    }
  }, [clickInfo])

  const handleClick = useCallback(
    (
      event: React.MouseEvent<HTMLButtonElement>,
      onClick?: (e: React.MouseEvent<HTMLButtonElement, MouseEvent>) => void
    ) => {
      const result = getIsHumanLikeClick()
      const isTrusted = (event as any).isTrusted

      if ((event as any).isTrusted && result.status) {
        onClick?.(event)
      } else {
        addTrace('Bot Identified', { data: { ...result, isTrusted } })
      }
    },
    [getIsHumanLikeClick]
  )

  return {
    handleMouseMove,
    handleMouseOver,
    handleFocus,
    handleClick,
    clickInfo,
  }
}
